module.exports = __webpack_public_path__ + "img/Halle_Leer 056.0f06c58d.jpg";